var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgConfirmationFilledIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 10,
    cy: 10,
    r: 9,
    fill: "#0084FF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15 7.86364C15 6.28045 13.7195 5 12.1364 5C10.6923 5 9.50591 6.06773 9.30545 7.45455H7.43182C7.16182 7.45455 6.93273 7.62636 6.85091 7.86364L6 10.3182V13.5909C6 13.8159 6.18409 14 6.40909 14H6.81818C7.04318 14 7.22727 13.8159 7.22727 13.5909V13.1818H12.1364V13.5909C12.1364 13.8159 12.3205 14 12.5455 14H12.9545C13.1795 14 13.3636 13.8159 13.3636 13.5909V10.4491C14.3291 9.98682 15 9.005 15 7.86364ZM7.43182 8.06818H9.285C9.33409 8.78818 9.64909 9.43455 10.1359 9.90909H6.81818L7.43182 8.06818ZM7.43182 11.9545C7.09227 11.9545 6.81818 11.6805 6.81818 11.3409C6.81818 11.0014 7.09227 10.7273 7.43182 10.7273C7.77136 10.7273 8.04545 11.0014 8.04545 11.3409C8.04545 11.6805 7.77136 11.9545 7.43182 11.9545ZM11.9318 11.9545C11.5923 11.9545 11.3182 11.6805 11.3182 11.3409C11.3182 11.0014 11.5923 10.7273 11.9318 10.7273C12.2714 10.7273 12.5455 11.0014 12.5455 11.3409C12.5455 11.6805 12.2714 11.9545 11.9318 11.9545ZM12.1364 9.90909C11.5677 9.90909 11.0891 9.70455 10.6923 9.30773C10.2955 8.91091 10.0909 8.43227 10.0909 7.86364C10.0909 7.30727 10.2955 6.82455 10.6923 6.43182C11.0891 6.02273 11.5677 5.81818 12.1364 5.81818C12.6927 5.81818 13.1755 6.02273 13.5682 6.43182C13.9773 6.82455 14.1818 7.30727 14.1818 7.86364C14.1818 8.43227 13.9773 8.91091 13.5682 9.30773C13.1755 9.70455 12.6927 9.90909 12.1364 9.90909ZM12.3409 7.96591L13.5109 8.65727L13.2041 9.15636L11.7273 8.27273V6.22727H12.3409V7.96591Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgConfirmationFilledIcon);
export default __webpack_public_path__ + "static/media/confirmation-filled-icon.516422dda0fe6a090329b5ef9d91c031.svg";
export { ForwardRef as ReactComponent };